<!-- InputField.svelte -->
<script lang="ts">
  import { onDestroy } from "svelte";
  import { Form } from "../lib/validation_next";
  import Tooltip from "./Tooltip.svelte";

  type InputType = "text" | "date" | "password" | "number";

  export let field: Form.Field<any>;
  export let label: string | undefined = undefined;

  export let customClass: string | undefined = undefined;
  export let customClassLabel: string | undefined = undefined;
  export let name: string | undefined = Math.random().toString();
  export let type: InputType = "text";
  export let tooltip: string | undefined = undefined;
  export let reserveErrorMsgHeight = false;
  export let outset = true;
  export let limitWidth = false;

  export let placeholder: string = "";
  export let disabled = false;
  export let img: string | undefined = undefined;
  export let imgClicked: (() => void) | undefined = undefined;

  export let onEnter: (() => void) | undefined = undefined;
  export let onEscape: (() => void) | undefined = undefined;

  const handleImgClicked = () => {
    if (imgClicked) {
      imgClicked();
    } else if (onEnter) {
      onEnter();
    }
  };

  let value = field.input;

  let hasChanged = false;
  let error: string | null = null;

  const unsubscribeOutput = field.output.subscribe((state) => {
    hasChanged = state.hasChanged;
    error = state.res.isOk() ? null : state.res.error;
  });

  const onKeyPress = (ke: KeyboardEvent) => {
    if (onEnter && ke.code === "Enter") {
      onEnter();
    } else if (onEscape && ke.code == "Escape") {
      onEscape();
    }
  };

  onDestroy(() => {
    unsubscribeOutput();
  });
</script>

<div
  class="break-inside-avoid-column {customClass}"
  class:w-full={!limitWidth}
  class:w-[250px]={limitWidth}
>
  {#if label}
    <label class="val-input-label {customClassLabel}" for={name}>{label}
      {#if tooltip}<Tooltip
          text={tooltip}
          customClass="inline"
          imgClass="px-[4px] mb-[-5px]"
        />{/if}</label>
  {/if}
  <div
    class:input-warning={error && hasChanged}
    class:outset
    class={`outset flex align-middle items-center input-field
      ${disabled ? "!bg-[#EEE] !border-[#D4D4D4]" : ""}`}
  >
    <input
      {disabled}
      {...{ type: type }}
      bind:value={$value}
      {name}
      id={name}
      {placeholder}
      on:keypress={onKeyPress}
      autocomplete="off"
      class:error={error && hasChanged}
      class:isOk={!error}
      class={`min-w-0 flex-grow pl-[16px] pr-[8px] border-none 
      outline-none h-[40px] datepicker-arrow-chromium
      ${disabled ? "!bg-[#EEE] text-[#D4D4D4] " : "!bg-transparent"}`}
    />
    {#if img}
      <button
        on:click={handleImgClicked}
        class={`h-[32px] ${disabled ? "opacity-20" : ""}`}
      >
        <img src={img} class="input-image pr-[12px]" alt="img" />
      </button>
    {/if}
  </div>
  {#if error && hasChanged}
    <span class="input-error-text">{error}</span>
  {/if}
  {#if reserveErrorMsgHeight && !(error && hasChanged)}
    <span class="input-error-text" style="visibility: hidden"
    >Phony error message</span>
  {/if}
</div>

<style lang="postcss" scoped>
  .datepicker-arrow-chromium::-webkit-calendar-picker-indicator {
    background: url("/icons/arrow-down.svg") no-repeat right;
    margin-right: 16px;
  }
</style>
